export const tokenSrouce = {
    TOKEN: '',
    UID: 0,
    os:'',
    vcode:'',
    serviceUrl:'',
    secret:'',//密钥
    encrypt:0,//是否加密
    msgAssistant:0,//是否开启群发助手，0-不开启，1-开启
    msgTranslate:0//是否开启翻译助手，0-不开启，1-开启
};

export const setToken = (val: string) => {
    tokenSrouce.TOKEN = val;
};
export const setOs = (val: string) => {
    tokenSrouce.os = val;
};
export const setSecret = (val: string) => {
    tokenSrouce.secret = val;
};

export const setEncrypt = (val: number) => {
    tokenSrouce.encrypt = val;
};

export const setUid = (val: number) => {
    tokenSrouce.UID = val;
};
export const setVcode = (val: string) => {
    tokenSrouce.vcode = val;
};
export const setServiceUrl = (val: string) => {
    tokenSrouce.serviceUrl = val;
};
export const setMsgAssistant = (val: number) => {
    tokenSrouce.msgAssistant = val;
};
export const setMsgTranslate = (val: number) => {
    tokenSrouce.msgTranslate = val;
};

export const getToken = () => tokenSrouce.TOKEN;
export const getUid = () => tokenSrouce.UID;
export const getOs = () => tokenSrouce.os;
export const getSecret = () => tokenSrouce.secret;
export const getEncrypt = () => tokenSrouce.encrypt;
export const getVcode = () => tokenSrouce.vcode;
export const getServiceUrl = () => tokenSrouce.serviceUrl;
export const getMsgAssistant = () => tokenSrouce.msgAssistant;
export const getMsgTranslate = () => tokenSrouce.msgTranslate;
